import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import SettingMapsService from "services/SettingMapsService";

export const getAllMapsApi = createAsyncThunk(
  "setting/maps/getAllMapsApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SettingMapsService.getAllMapsApi();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const setActiveMapApi = createAsyncThunk(
  "setting/maps/setActiveMapApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SettingMapsService.setActiveMapApi(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  mapsList: [],
};
export const settingMapsSlice = createSlice({
  name: "setting-maps",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllMapsApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMapsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.mapsList = action.payload;
      })
      .addCase(getAllMapsApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(setActiveMapApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(setActiveMapApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(setActiveMapApi.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = settingMapsSlice.actions;

export default settingMapsSlice.reducer;
